import React, { useEffect, useState } from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import styled from 'styled-components'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import { useTranslation } from 'react-i18next'
import { TextField } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
)

const StyledMultiSelect = styled.div<any>``

export default function MultiSelect({
  defaultValue,
  options,
  primary,
  value,
  validation,
  formFieldName,
  ...props
}: any): any {
  const classes = useStyles()
  const { t } = useTranslation()
  const [selectValue, setSelectValue] = useState('')

  useEffect(() => {
    if (validation && value) {
      if (validation(value, options, formFieldName) === false) {
        setSelectValue('')
      }
    }
  }, [value, options, validation, formFieldName])

  useEffect(() => {
    setSelectValue(value)
  }, [value, setSelectValue])

  return (
    <StyledMultiSelect>
      <FormControl className={classes.formControl}>
        <TextField
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={selectValue}
          select
          variant="outlined"
          {...props}
        >
          {options
            .sort((a, b) => t(a.label).localeCompare(t(b.label)))
            .map((option, index) => (
              <MenuItem key={option.label + index} value={option.value}>
                {t(option.label)}
              </MenuItem>
            ))}
        </TextField>
      </FormControl>
    </StyledMultiSelect>
  )
}
